import { render } from "./JFreturn.vue?vue&type=template&id=a5cf026e&scoped=true"
import script from "./JFreturn.vue?vue&type=script&lang=js"
export * from "./JFreturn.vue?vue&type=script&lang=js"

import "./JFreturn.vue?vue&type=style&index=0&id=a5cf026e&lang=scss&scoped=true"
import "./JFreturn.vue?vue&type=style&index=1&id=a5cf026e&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cf026e"]])

export default __exports__